import { TRAINING_SPOT_KINDS } from '@nine/shared';
import { bamboo, cloud, figure, peak } from '../kit';
import { C, type Hex } from '../pix';
import { defineIconKind, registerIcons } from '../store';

/** Training-spot kinds (จุดฝึกวิชา): the place itself on a tile of its colour. */

const SPOT_TINT: Readonly<Record<string, Hex>> = {
  waterfall: '#3a9ad8',
  cave: '#8a7a6a',
  peak: '#7a9ac0',
  bamboo: '#4ab05a',
  hotSpring: '#3ac0b0',
  shrine: '#c84a3a',
  shore: '#2a7ac8',
};

defineIconKind('spot', {
  label: 'จุดฝึกวิชา',
  ids: () => Object.keys(TRAINING_SPOT_KINDS),
  name: (id) => TRAINING_SPOT_KINDS[id as keyof typeof TRAINING_SPOT_KINDS] ?? id,
  tint: (id) => SPOT_TINT[id] ?? C.gold,
  plate: 'square',
  fallback: () => ({ draw: (p) => peak(p, 16, 26, 22, 18, C.steelMid) }),
});

registerIcons('spot', {
  waterfall: (p) => {
    p.rect(3, 4, 8, 24, '#7a6e5c');
    p.rect(22, 4, 7, 24, '#7a6e5c');
    p.rect(11, 4, 11, 22, '#8ad0ff');
    for (let x = 12; x < 22; x += 2) p.line(x, 4, x, 25, x % 4 ? C.white : '#bfeaff');
    p.ell(16, 26, 10, 3, C.white);
  },
  cave: (p) => {
    p.ell(16, 20, 14, 13, '#8a7a6a');
    p.ell(16, 23, 8, 9, '#24142c');
    p.rect(3, 27, 26, 2, '#6a5a4a');
    for (const x of [10, 15, 20]) p.line(x, 14, x, 17, '#a89a88');
  },
  peak: (p) => {
    peak(p, 12, 28, 18, 22, '#6a7a98');
    peak(p, 22, 28, 16, 16, '#8a9ab8');
    cloud(p, 4, 22, 12, C.white);
    figure(p, 10, 2, C.white, 'sit');
  },
  bamboo: (p) => {
    bamboo(p, 7, 29, 3, '#5cc04a');
    bamboo(p, 15, 29, 6, '#7ad85a');
    bamboo(p, 23, 29, 2, '#5cc04a');
  },
  hotSpring: (p) => {
    p.ell(16, 22, 13, 6, '#8a7a6a');
    p.ell(16, 22, 11, 4, '#7ae0e0');
    for (const x of [10, 16, 22])
      for (let y = 4; y < 16; y++) p.px(x + Math.round(Math.sin(y / 1.7 + x)), y, C.white);
  },
  shrine: (p) => {
    p.rect(4, 6, 24, 3, '#c84a3a');
    p.rect(2, 5, 28, 1, '#2a1e1a');
    p.rect(6, 11, 20, 2, '#c84a3a');
    p.rect(8, 9, 3, 20, '#c84a3a').rect(21, 9, 3, 20, '#c84a3a');
    p.rect(13, 22, 6, 7, '#8a7a6a');
    p.px(16, 20, '#ffd060');
  },
  shore: (p) => {
    p.rect(3, 18, 26, 11, '#3a8ac8');
    for (let k = 0; k < 3; k++)
      for (let x = 3; x < 29; x++)
        p.px(x, 18 + k * 4 + Math.round(Math.sin(x / 2 + k * 2)), k ? '#7ac8f0' : C.white);
    p.ell(9, 17, 6, 4, '#8a7a6a');
    p.ell(26, 6, 3, 3, '#fff0a8');
  },
});
